var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8StarUnfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffb91e",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,1c-0.41255,0.00036 -0.78255,0.254 -0.93164,0.63867l-6.16602,15.89648l-16.95313,0.86523c-0.41309,0.02091 -0.77069,0.29396 -0.89967,0.68696c-0.12898,0.393 -0.00272,0.82485 0.31764,1.08648l13.20117,10.79297l-4.33594,16.37695c-0.10595,0.39905 0.04421,0.82219 0.37801,1.06519c0.3338,0.243 0.78261,0.25589 1.12981,0.03247l14.25977,-9.15234l14.25977,9.15234c0.3472,0.22343 0.79601,0.21053 1.12981,-0.03247c0.3338,-0.243 0.48396,-0.66614 0.37801,-1.06519l-4.33594,-16.37695l13.20117,-10.79297c0.32037,-0.26163 0.44662,-0.69348 0.31764,-1.08648c-0.12898,-0.393 -0.48658,-0.66605 -0.89967,-0.68696l-16.95312,-0.86523l-6.16602,-15.89648c-0.14909,-0.38467 -0.51909,-0.63831 -0.93164,-0.63867zM25,4.76367l5.4668,14.09766c0.14289,0.36781 0.4887,0.61722 0.88281,0.63672l15.00977,0.76758l-11.69141,9.56055c-0.30336,0.24804 -0.43392,0.6504 -0.33398,1.0293l3.8418,14.51367l-12.63477,-8.11133c-0.32954,-0.21196 -0.75249,-0.21196 -1.08203,0l-12.63477,8.11133l3.8418,-14.51367c0.09993,-0.3789 -0.03062,-0.78126 -0.33399,-1.0293l-11.69141,-9.56055l15.00977,-0.76758c0.39411,-0.0195 0.73992,-0.26891 0.88281,-0.63672z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8StarUnfilled);
export default __webpack_public_path__ + "static/media/icons8-star-unfilled.4207f9f0f9431ff630c715c7a490ee53.svg";
export { ForwardRef as ReactComponent };